import React, { useEffect, useState } from "react";
import UserLayout from "../layout/UserLayout";

const ITEMS_PER_PAGE = 12;

const RiceProducts = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);

  useEffect(() => {
    fetch("https://ceymoslanka.com/backend/api/rice_manager/get_rice_products.php")
      .then((res) => res.json())
      .then((data) => {
        setProducts(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  const totalPages = Math.ceil(products.length / ITEMS_PER_PAGE);
  const startIndex = (page - 1) * ITEMS_PER_PAGE;
  const current = products.slice(startIndex, startIndex + ITEMS_PER_PAGE);

  return (
    <UserLayout>
      <div className="max-w-6xl mx-auto px-4 pt-24 pb-16">

        <h1 className="text-4xl font-bold text-gray-900">Sri Lankan Rice</h1>
        <div className="w-20 h-[3px] bg-gray-900 mt-1 mb-6"></div>

        {/* Description */}
        <p className="text-gray-700 text-lg w-full mb-4">
          Sri Lankan rice is renowned for its 
          <span className="font-semibold text-[#C8A951]"> unique aroma</span>,
          <span className="font-semibold text-[#C8A951]"> distinct texture</span>,
          and exceptional nutritional value. Cultivated for generations, these grains are 
          harvested with natural farming methods that preserve purity and heritage.
        </p>

        <p className="text-gray-700 text-base w-full mb-6">
          From fragrant red rice to soft white heirloom varieties, Sri Lankan rice is rich in 
          <span className="italic text-[#C8A951]"> antioxidants</span>,
          <span className="italic text-[#C8A951]"> minerals</span>,
          and <span className="italic text-[#C8A951]">fiber</span>, making it one of the 
          most nutritious staple foods in the world.
        </p>

        {loading ? (
          <p className="text-center text-gray-600">Loading products...</p>
        ) : (
          <>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
              {current.map((p) => (
                <a
                  key={p.id}
                  href={`/rice/${p.id}`}
                  className="border rounded-lg bg-white shadow-sm hover:shadow-md transition block"
                >
                  <img
                    src={
                      p.image
                        ? `https://ceymoslanka.com/backend/uploads/rice_products/${p.image}`
                        : "https://via.placeholder.com/400x300?text=No+Image"
                    }
                    alt={p.title}
                    className="w-full h-56 object-cover rounded-t-lg"
                  />

                  <div className="p-4">
                    <h3 className="text-lg font-semibold text-gray-900">{p.title}</h3>
                    <p className="text-gray-800 font-medium mt-3">
                      Net Weight: {p.net_weight}
                    </p>
                  </div>
                </a>
              ))}
            </div>

            {/* Pagination */}
            <div className="flex justify-center gap-2 mt-10">
              {Array.from({ length: totalPages }, (_, i) => i + 1).map((num) => (
                <button
                  key={num}
                  onClick={() => setPage(num)}
                  className={
                    num === page
                      ? "px-4 py-2 border border-gray-800 rounded text-gray-900 font-semibold"
                      : "px-4 py-2 border rounded text-gray-600 hover:bg-gray-100"
                  }
                >
                  {num}
                </button>
              ))}
            </div>
          </>
        )}

      </div>
    </UserLayout>
  );
};

export default RiceProducts;
